import { ContentWithAside } from "layouts/kiosk-h"
import { LiveTrafficKioskHPage } from "./pages/em-live-traffic/index.kiosk"

export const emLiveTraffic = {
  themeOptionFactories: null,
  ignoreAppThemeFactory: false,
  routes: {
    mobile: [],
    "kiosk-v": [],
    "kiosk-h": [
      {
        path: "live-traffic",
        element: <LiveTrafficKioskHPage Layout={ContentWithAside} />,
      },
    ],
  },
}
